var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('user.inactivate') && !_vm.loading)?_c('button',{staticClass:"btn btn-danger btn-fill btn-icon",attrs:{"type":"button","title":"Desativar"},on:{"click":function($event){return _vm.handleInactivate()}}},[_c('i',{staticClass:"ti-unlink"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a7236e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Users/InactivateUserAction.vue
// module id = YKxY
// module chunks = 10